import React from 'react';
import {
  File, FileArchive, FileImage, FileSpreadsheet, FileText, FileType, Presentation, Ruler,
} from 'lucide-react';
import { DateiArtId, dateiArt } from './dokumenteLogic';

/**
 * Das Sinnbild links am Dokument — Form UND Farbe nach Dateiart, darunter das
 * Kuerzel im Klartext.
 *
 * Warum beides: die Sinnbilder von Word, PDF und Text unterscheiden sich in
 * einer 16-px-Zeile kaum, und Farbe allein traegt die Unterscheidung nicht
 * (Rot-Gruen-Schwaeche, Schwarz-Weiss-Ausdruck). Das Kuerzel ist der
 * verlaessliche Teil, Form und Farbe machen ihn schnell.
 *
 * Die Farben sind bewusst die gewohnten Programmfarben (PDF rot, Word blau,
 * Excel gruen) — sie muessen nicht erklaert werden.
 */
const ART_STIL: Record<DateiArtId, { Icon: React.ElementType; klasse: string }> = {
  pdf: { Icon: FileText, klasse: 'bg-rose-50 text-rose-600 border-rose-100' },
  word: { Icon: FileType, klasse: 'bg-blue-50 text-blue-700 border-blue-100' },
  excel: { Icon: FileSpreadsheet, klasse: 'bg-emerald-50 text-emerald-700 border-emerald-100' },
  powerpoint: { Icon: Presentation, klasse: 'bg-orange-50 text-orange-600 border-orange-100' },
  bild: { Icon: FileImage, klasse: 'bg-violet-50 text-violet-600 border-violet-100' },
  cad: { Icon: Ruler, klasse: 'bg-cyan-50 text-cyan-700 border-cyan-100' },
  archiv: { Icon: FileArchive, klasse: 'bg-amber-50 text-amber-700 border-amber-100' },
  text: { Icon: FileText, klasse: 'bg-slate-100 text-slate-600 border-slate-200' },
  sonstige: { Icon: File, klasse: 'bg-slate-100 text-slate-500 border-slate-200' },
};

interface Props {
  dateiname: string;
  mime?: string | null;
}

export const DateiIcon: React.FC<Props> = ({ dateiname, mime }) => {
  const art = dateiArt(dateiname, mime);
  const { Icon, klasse } = ART_STIL[art.id];
  return (
    <div
      title={art.label}
      className={`w-11 shrink-0 flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-lg border ${klasse}`}
    >
      <Icon className="w-4 h-4" />
      <span className="text-[9px] font-bold leading-none tracking-wide">{art.kuerzel}</span>
    </div>
  );
};
